(function () {
  var focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'textarea',
    'input',
    'select',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function initSizeFinderModal(root) {
    var scope = root || document;
    var openButtons = Array.prototype.slice.call(scope.querySelectorAll('[data-self-size-quiz-open]'));

    openButtons.forEach(function (openButton) {
      var controls = openButton.getAttribute('aria-controls');
      var modal = controls ? document.getElementById(controls) : null;
      if (!modal || modal.dataset.selfSizeQuizReady === 'true') return;

      modal.dataset.selfSizeQuizReady = 'true';
      var dialog = modal.querySelector('.self-size-quiz-modal__dialog');
      var closeButtons = Array.prototype.slice.call(modal.querySelectorAll('[data-self-size-quiz-close]'));
      var topBackButton = modal.querySelector('[data-self-size-quiz-top-back]');
      var cards = Array.prototype.slice.call(modal.querySelectorAll('[data-self-size-quiz-card]'));
      var styleGrid = modal.querySelector('[data-self-size-quiz-style-grid]');
      var styleCards = [];
      var productRow = modal.querySelector('[data-self-size-quiz-product-row]');
      var productCards = [];
      var productPrevButton = modal.querySelector('.self-size-quiz-modal__carousel-arrow--prev');
      var productNextButton = modal.querySelector('.self-size-quiz-modal__carousel-arrow--next');
      var nextButton = modal.querySelector('[data-self-size-quiz-next]');
      var prevButton = modal.querySelector('[data-self-size-quiz-prev]');
      var count = modal.querySelector('[data-self-size-quiz-count]');
      var progress = modal.querySelector('[data-self-size-quiz-progress]');
      var bandResult = modal.querySelector('[data-self-size-quiz-band]');
      var cupResult = modal.querySelector('[data-self-size-quiz-cup]');
      var primaryResultLabel = modal.querySelector('[data-self-size-quiz-primary-label]');
      var secondaryResultLabel = modal.querySelector('[data-self-size-quiz-secondary-label]');
      var browseLink = modal.querySelector('[data-self-size-quiz-browse]');
      var dataRoot = modal.querySelector('[data-self-size-quiz-data]');
      var steps = Array.prototype.slice.call(modal.querySelectorAll('[data-self-size-quiz-step]'));
      var lastFocus = null;
      var activeStep = 1;
      var answers = {
        categoryKey: '',
        category: '',
        categoryUrl: '',
        categoryImage: '',
        styleKey: '',
        style: '',
        productKey: '',
        product: '',
        productUrl: '',
        primaryLabel: '',
        primaryValue: '',
        secondaryLabel: '',
        secondaryValue: ''
      };

      var styleOptions = dataRoot ? Array.prototype.slice.call(dataRoot.querySelectorAll('[data-self-size-quiz-style-option]')).map(function (item) {
        return {
          categoryKey: item.getAttribute('data-category-key') || '',
          styleKey: item.getAttribute('data-style-key') || '',
          label: item.getAttribute('data-label') || '',
          image: item.getAttribute('data-image') || ''
        };
      }) : [];

      var productOptions = dataRoot ? Array.prototype.slice.call(dataRoot.querySelectorAll('[data-self-size-quiz-product-option]')).map(function (item) {
        return {
          categoryKey: item.getAttribute('data-category-key') || '',
          styleKey: item.getAttribute('data-style-key') || '',
          productKey: item.getAttribute('data-product-key') || '',
          title: item.getAttribute('data-title') || '',
          searchText: item.getAttribute('data-search-text') || '',
          url: item.getAttribute('data-url') || '',
          image: item.getAttribute('data-image') || '',
          primaryLabel: item.getAttribute('data-primary-label') || '',
          primaryValue: item.getAttribute('data-primary-value') || '',
          secondaryLabel: item.getAttribute('data-secondary-label') || '',
          secondaryValue: item.getAttribute('data-secondary-value') || ''
        };
      }) : [];

      var unavailableProductKeys = ['no-show-sculpt-thong'];
      var productUrlAliases = {
        'open-back-shaping-thong-bodysuit': '/products/open-back-shaping-thong-bodysuit-2'
      };

      function escapeHtml(value) {
        return String(value || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');
      }

      function getInferredStyleKeys(product) {
        var haystack = String(product.searchText || product.title || '').toLowerCase();
        var keys = String(product.styleKey || '').split(/\s+/).filter(Boolean);
        var add = function (key, matches) {
          if (matches && keys.indexOf(key) === -1) keys.push(key);
        };

        if (product.categoryKey === 'bras') {
          add('wireless-bras', /wireless|wire-free|bralette/.test(haystack));
          add('t-shirt-bras', /t[ -]?shirt/.test(haystack));
          add('full-coverage-bras', /full[ -]?coverage|minimizer|wide[ -]?strap/.test(haystack));
          add('push-up-bras', /push[ -]?up|lift/.test(haystack));
          add('strapless-bras', /strapless|convertible/.test(haystack));
          add('plunge-bras', /plunge|deep[ -]?v|low[ -]?cut/.test(haystack));
          add('bralettes', /bralette/.test(haystack));
          add('minimizer-bras', /minimizer/.test(haystack));
          add('unlined-bras', /unlined|sheer|mesh/.test(haystack));
        } else if (product.categoryKey === 'underwear') {
          add('tummy-control-underwear', /tummy|control|sculpt|shap|smooth|support/.test(haystack));
          add('high-waisted-underwear', /high[ -]?waist/.test(haystack));
          add('briefs', /brief/.test(haystack));
          add('thongs', /thong/.test(haystack));
          add('butt-lifting-underwear', /butt|lift/.test(haystack));
          add('mid-waisted-underwear', /mid[ -]?waist/.test(haystack));
        } else if (product.categoryKey === 'tanks-camis') {
          add('tank-tops', /tank/.test(haystack));
          add('camis', /cami/.test(haystack));
        } else if (product.categoryKey === 'bodysuits') {
          add('brief-style-bodysuits', /brief/.test(haystack));
          add('thong-bodysuits', /thong/.test(haystack));
          add('full-length-bodysuits', /full[ -]?length|catsuit|romper|mid[ -]?thigh/.test(haystack));
          add('strapless-bodysuits', /strapless/.test(haystack));
          add('open-back-bodysuits', /open[ -]?back/.test(haystack));
          add('long-sleeve-bodysuits', /long[ -]?sleeve/.test(haystack));
          add('short-sleeve-bodysuits', /short[ -]?sleeve/.test(haystack));
          add('zip-up-bodysuits', /zip[ -]?up|front[ -]?zip/.test(haystack));
        }

        return keys;
      }

      function productMatchesStyle(product, styleKey) {
        return getInferredStyleKeys(product).indexOf(styleKey) !== -1;
      }

      function getProductKeyFromUrl(url) {
        var match = String(url || '').match(/\/products\/([^/?#]+)/);
        return match ? match[1] : '';
      }

      function getResolvedProductUrl(product) {
        var productKey = product.productKey || getProductKeyFromUrl(product.url);
        return productUrlAliases[productKey] || product.url || answers.categoryUrl || '';
      }

      function isAvailableProductOption(product) {
        var productKey = product.productKey || getProductKeyFromUrl(product.url);
        return unavailableProductKeys.indexOf(productKey) === -1;
      }

      function bindStyleCards() {
        styleCards = Array.prototype.slice.call(modal.querySelectorAll('[data-self-size-quiz-style]'));
        styleCards.forEach(function (card) {
          card.setAttribute('aria-pressed', 'false');
          card.addEventListener('click', function () {
            styleCards.forEach(function (item) {
              item.classList.toggle('is-selected', item === card);
              item.setAttribute('aria-pressed', item === card ? 'true' : 'false');
            });

            answers.styleKey = card.getAttribute('data-style-key') || '';
            answers.style = card.getAttribute('data-self-size-quiz-style') || '';
            answers.productKey = '';
            answers.product = '';
            answers.productUrl = '';
            answers.primaryLabel = '';
            answers.primaryValue = '';
            answers.secondaryLabel = '';
            answers.secondaryValue = '';
            modal.dataset.selectedStyle = answers.style;
            modal.dataset.selectedProduct = '';
            renderProductOptions();
            if (activeStep === 2 && nextButton) nextButton.disabled = false;
          });
        });
      }

      function renderStyleOptions() {
        if (!styleGrid) return;
        var options = styleOptions.filter(function (option) {
          if (option.categoryKey !== answers.categoryKey) return false;
          return productOptions.some(function (product) {
            return product.categoryKey === answers.categoryKey && productMatchesStyle(product, option.styleKey);
          });
        });

        styleGrid.innerHTML = options.map(function (option) {
          var safeLabel = escapeHtml(option.label);
          var safeStyleKey = escapeHtml(option.styleKey);
          var safeImage = escapeHtml(option.image || answers.categoryImage);
          return [
            '<button class="self-size-quiz-modal__style-card" type="button" data-self-size-quiz-style="' + safeLabel + '" data-style-key="' + safeStyleKey + '">',
              '<span class="self-size-quiz-modal__style-media">',
                '<img src="' + safeImage + '" alt="" width="130" height="142" loading="lazy">',
              '</span>',
              '<span class="self-size-quiz-modal__style-label">' + safeLabel + '</span>',
            '</button>'
          ].join('');
        }).join('');
        bindStyleCards();
      }

      function bindProductCards() {
        productCards = Array.prototype.slice.call(modal.querySelectorAll('[data-self-size-quiz-product]'));
        productCards.forEach(function (card) {
          card.setAttribute('aria-pressed', 'false');
          card.addEventListener('click', function () {
            productCards.forEach(function (item) {
              item.classList.toggle('is-selected', item === card);
              item.setAttribute('aria-pressed', item === card ? 'true' : 'false');
            });

            answers.productKey = card.getAttribute('data-product-key') || '';
            answers.product = card.getAttribute('data-self-size-quiz-product') || '';
            answers.productUrl = card.getAttribute('data-product-url') || answers.categoryUrl || '';
            answers.primaryLabel = card.getAttribute('data-primary-label') || '';
            answers.primaryValue = card.getAttribute('data-primary-value') || '';
            answers.secondaryLabel = card.getAttribute('data-secondary-label') || '';
            answers.secondaryValue = card.getAttribute('data-secondary-value') || '';
            modal.dataset.selectedProduct = answers.product;
            if (activeStep === 3 && nextButton) nextButton.disabled = false;
          });
        });
      }

      function getMatchingProducts() {
        var exactMatches = productOptions.filter(function (option) {
          return isAvailableProductOption(option) && option.categoryKey === answers.categoryKey && productMatchesStyle(option, answers.styleKey);
        });

        return exactMatches;
      }

      function renderProductOptions() {
        if (!productRow) return;
        var products = getMatchingProducts();
        var fallbackImage = productRow.getAttribute('data-fallback-image') || answers.categoryImage || '';

        productRow.innerHTML = products.length ? products.map(function (product) {
          var safeTitle = escapeHtml(product.title);
          var safeImage = escapeHtml(product.image || fallbackImage);
          return [
            '<button class="self-size-quiz-modal__product-card" type="button" data-self-size-quiz-product="' + safeTitle + '" data-product-key="' + escapeHtml(product.productKey) + '" data-product-url="' + escapeHtml(getResolvedProductUrl(product)) + '" data-primary-label="' + escapeHtml(product.primaryLabel) + '" data-primary-value="' + escapeHtml(product.primaryValue) + '" data-secondary-label="' + escapeHtml(product.secondaryLabel) + '" data-secondary-value="' + escapeHtml(product.secondaryValue) + '">',
              '<span class="self-size-quiz-modal__product-media">',
                '<img src="' + safeImage + '" alt="" width="222" height="247" loading="lazy">',
              '</span>',
              '<span class="self-size-quiz-modal__product-title">' + safeTitle + '</span>',
            '</button>'
          ].join('');
        }).join('') : '<p class="self-size-quiz-modal__empty">No products are currently available for this style. Please go back and choose another style.</p>';

        if (productPrevButton) productPrevButton.hidden = products.length < 2;
        if (productNextButton) productNextButton.hidden = products.length < 2;

        bindProductCards();
      }

      function scrollProductRow(direction) {
        if (!productRow) return;
        var firstCard = productRow.querySelector('[data-self-size-quiz-product]');
        var scrollDistance = firstCard ? firstCard.offsetWidth + 24 : 246;
        productRow.scrollBy({ left: scrollDistance * direction, behavior: 'smooth' });
      }

      function clearSelections() {
        answers.category = '';
        answers.categoryKey = '';
        answers.categoryUrl = '';
        answers.categoryImage = '';
        answers.style = '';
        answers.styleKey = '';
        answers.product = '';
        answers.productKey = '';
        answers.productUrl = '';
        answers.primaryLabel = '';
        answers.primaryValue = '';
        answers.secondaryLabel = '';
        answers.secondaryValue = '';
        modal.dataset.selectedCategory = '';
        modal.dataset.selectedStyle = '';
        modal.dataset.selectedProduct = '';
        cards.concat(styleCards, productCards).forEach(function (item) {
          item.classList.remove('is-selected');
          item.setAttribute('aria-pressed', 'false');
        });
        if (styleGrid) styleGrid.innerHTML = '';
        styleCards = [];
        if (productRow) productRow.innerHTML = '';
        productCards = [];
      }

      function hasRequiredSelection(step) {
        if (step === 1) return Boolean(answers.category);
        if (step === 2) return Boolean(answers.style);
        if (step === 3) return Boolean(answers.product);
        if (step === 'result') return true;
        return false;
      }

      function getBrowseUrl() {
        if (answers.productUrl) return answers.productUrl;
        if (answers.categoryUrl) return answers.categoryUrl;
        return '/collections/all';
      }

      function getProductSizeFinderUrl() {
        var url = getBrowseUrl();
        if (!url || url.indexOf('/products/') === -1) return url;

        var hash = '';
        var hashIndex = url.indexOf('#');
        if (hashIndex !== -1) {
          hash = url.slice(hashIndex);
          url = url.slice(0, hashIndex);
        }

        return url + (url.indexOf('?') === -1 ? '?' : '&') + 'open-size-finder=1' + hash;
      }

      function updateResult() {
        var productResult = modal.querySelector('[data-self-size-quiz-result-product]');
        if (productResult) {
          productResult.textContent = answers.product
            ? 'Open the dedicated Size Finder calculator and measurement guide for ' + answers.product + '.'
            : "Open this product's dedicated Size Finder calculator and measurement guide.";
        }
        if (primaryResultLabel && answers.primaryLabel) primaryResultLabel.textContent = answers.primaryLabel;
        if (secondaryResultLabel && answers.secondaryLabel) secondaryResultLabel.textContent = answers.secondaryLabel;
        if (bandResult && answers.primaryValue) bandResult.textContent = answers.primaryValue;
        if (cupResult && answers.secondaryValue) cupResult.textContent = answers.secondaryValue;
        if (browseLink) {
          browseLink.setAttribute('href', getProductSizeFinderUrl());
          browseLink.textContent = 'Find My Size';
        }
        modal.dataset.recommendedPrimary = answers.primaryValue || '';
        modal.dataset.recommendedSecondary = answers.secondaryValue || '';
      }

      function setStep(step) {
        activeStep = step;
        var isResult = step === 'result';
        steps.forEach(function (stepPanel) {
          var isActive = stepPanel.getAttribute('data-self-size-quiz-step') === String(step);
          stepPanel.hidden = !isActive;
          stepPanel.classList.toggle('is-active', isActive);
        });

        if (isResult) updateResult();
        if (dialog) dialog.dataset.step = isResult ? 'result' : String(step);
        if (count && !isResult) count.textContent = step + '/3';
        if (progress && !isResult) progress.style.width = ((step / 3) * 100).toFixed(3) + '%';
        if (prevButton) prevButton.disabled = step === 1 || isResult;
        if (nextButton) nextButton.disabled = isResult || !hasRequiredSelection(step);
      }

      function openModal() {
        lastFocus = document.activeElement;
        clearSelections();
        setStep(1);
        modal.hidden = false;
        document.body.classList.add('self-size-quiz-lock');
        document.addEventListener('keydown', onKeydown);
        window.requestAnimationFrame(function () {
          if (dialog) dialog.focus({ preventScroll: true });
        });
      }

      function closeModal() {
        modal.hidden = true;
        document.body.classList.remove('self-size-quiz-lock');
        document.removeEventListener('keydown', onKeydown);
        if (lastFocus && typeof lastFocus.focus === 'function') {
          lastFocus.focus({ preventScroll: true });
        }
      }

      function onKeydown(event) {
        if (event.key === 'Escape') {
          closeModal();
          return;
        }

        if (event.key !== 'Tab' || !dialog) return;

        var focusable = Array.prototype.slice.call(dialog.querySelectorAll(focusableSelector));
        if (!focusable.length) return;

        var first = focusable[0];
        var last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      openButton.addEventListener('click', openModal);
      closeButtons.forEach(function (button) {
        button.addEventListener('click', closeModal);
      });

      if (topBackButton) {
        topBackButton.addEventListener('click', function () {
          if (typeof activeStep === 'number' && activeStep > 1) {
            setStep(activeStep - 1);
          } else {
            closeModal();
          }
        });
      }

      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          cards.forEach(function (item) {
            item.classList.toggle('is-selected', item === card);
            item.setAttribute('aria-pressed', item === card ? 'true' : 'false');
          });

          answers.categoryKey = card.getAttribute('data-self-size-quiz-card') || '';
          answers.category = card.getAttribute('data-category-label') || card.textContent.trim();
          answers.categoryUrl = card.getAttribute('data-category-url') || '';
          answers.categoryImage = card.getAttribute('data-category-image') || '';
          answers.style = '';
          answers.styleKey = '';
          answers.product = '';
          answers.productKey = '';
          answers.productUrl = '';
          modal.dataset.selectedStyle = '';
          modal.dataset.selectedProduct = '';
          renderStyleOptions();
          renderProductOptions();
          modal.dataset.selectedCategory = answers.category;
          if (activeStep === 1 && nextButton) nextButton.disabled = false;
        });

        card.setAttribute('aria-pressed', 'false');
      });

      if (prevButton) {
        prevButton.addEventListener('click', function () {
          if (typeof activeStep === 'number' && activeStep > 1) setStep(activeStep - 1);
        });
      }

      if (productPrevButton) {
        productPrevButton.addEventListener('click', function () {
          scrollProductRow(-1);
        });
      }

      if (productNextButton) {
        productNextButton.addEventListener('click', function () {
          scrollProductRow(1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', function () {
          if (activeStep === 1 && answers.category) {
            setStep(2);
          } else if (activeStep === 2 && answers.style) {
            setStep(3);
          } else if (activeStep === 3 && answers.product) {
            setStep('result');
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSizeFinderModal(document);
    });
  } else {
    initSizeFinderModal(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSizeFinderModal(event.target);
  });
})();
